import { useState } from 'react'
import SiteButton from '@/components/atoms/SiteButton'
import NavIndustriesDropdown from '@/components/molecules/NavIndustriesDropdown'
import NavResourcesDropdown from '@/components/molecules/NavResourcesDropdown'
import unimoLogo from '@/assets/illustrations/unimo logo.svg'

// Temporarily hidden (Sept 2026) — the Resources pages are internal sign-off
// stubs, not real content. Flip to true to restore the dropdown in both the
// desktop and mobile menus.
const SHOW_RESOURCES_DROPDOWN = false

export function SiteNav() {
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    return (
        <nav className="relative py-4">
            <div className="flex items-center justify-between">
                <a href="/" className="flex items-center">
                    <img src={unimoLogo} alt="unimo" className="h-8 w-auto" />
                </a>

                <div className="hidden items-center gap-8 md:flex">
                    {/* Match the dropdowns’ 16px caret plus 4px label gap. */}
                    <a href="/pricing" className="pr-5 font-medium text-unimo-slate">
                        Pricing
                    </a>
                    {SHOW_RESOURCES_DROPDOWN && <NavResourcesDropdown />}
                    <NavIndustriesDropdown />
                    <SiteButton href="/contact?topic=pricing">Contact us</SiteButton>
                </div>

                <button
                    type="button"
                    aria-expanded={isMenuOpen}
                    aria-controls="site-nav-mobile-menu"
                    aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
                    onClick={() => setIsMenuOpen((open) => !open)}
                    className="text-unimo-slate md:hidden"
                >
                    <svg aria-hidden="true" className="h-6 w-6" viewBox="0 0 24 24" fill="none">
                        {isMenuOpen ? (
                            <path
                                d="M6 6L18 18M18 6L6 18"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        ) : (
                            <path
                                d="M4 7H20M4 12H20M4 17H20"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        )}
                    </svg>
                </button>
            </div>

            {isMenuOpen && (
                <div id="site-nav-mobile-menu" className="mt-4 flex flex-col gap-4 md:hidden">
                    <a href="/pricing" className="font-medium text-unimo-slate">
                        Pricing
                    </a>
                    {SHOW_RESOURCES_DROPDOWN && <NavResourcesDropdown />}
                    <NavIndustriesDropdown />
                    <SiteButton href="/contact?topic=pricing" className="w-fit">
                        Contact us
                    </SiteButton>
                </div>
            )}
        </nav>
    )
}

export default SiteNav
